module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "pagination text-lighter"
  }, [_c('li', {
    staticClass: "go-btn",
    class: {
      disable: _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.currentPage - 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/launchPreview/arrow-left.png",
      "alt": "上一页"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.go(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pages[0] > 2),
      expression: "pages[0] > 2"
    }]
  }, [_vm._v("...")]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      class: {
        active: _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.go(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pages[_vm.pages.length - 1] < _vm.totalPage - 1),
      expression: "pages[pages.length - 1] < totalPage - 1"
    }]
  }, [_vm._v("...")]), _vm._v(" "), _c('li', {
    staticClass: "go-btn",
    class: {
      disable: _vm.currentPage === _vm.totalPage
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.currentPage + 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/launchPreview/arrow-right.png",
      "alt": "下一页"
    }
  })]), _vm._v(" "), (_vm.showJump && _vm.totalPage > 1) ? _c('li', {
    staticClass: "page-jump"
  }, [_c('span', [_vm._v("共"), _c('em', [_vm._v(_vm._s(_vm.totalPage))]), _vm._v("页，跳转至")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jumpPage),
      expression: "jumpPage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.totalPage
    },
    domProps: {
      "value": _vm._s(_vm.jumpPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.jumpPage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("页")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.go(_vm.jumpPage)
      }
    }
  }, [_vm._v("确定")])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6699e300!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/pagination/pagination.vue
// module id = 447
// module chunks = 2